// Taken as one list Te doen (golf 10, B51): Nieuw (not looked at yet), Ingepland per day, Zonder dag per kind
// (category). Pure, so the grouping can be tested without a browser.

export interface TodoTask {
  id: string;
  status: string;
  category_id?: string | null;
  created_at: string;
  ai_state?: string | null;
}

export interface TodoEntry {
  plan_date: string;
}

export interface TodoCategory {
  id: string;
  name: string;
  position: number;
}

export interface TodoGroups<T extends TodoTask> {
  /** Captured, not looked at yet (status inbox); what waits in Te controleren is shown there, not twice. */
  fresh: T[];
  /** Planned on a day, the nearest day first. */
  planned: { date: string; tasks: T[] }[];
  /** Without a day, per kind in the order of Meer > Categorieën; null (Overig) last. */
  undated: { category: TodoCategory | null; tasks: T[] }[];
}

const newestFirst = (a: TodoTask, b: TodoTask) => (a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0);
const oldestFirst = (a: TodoTask, b: TodoTask) => -newestFirst(a, b);

export function groupTodo<T extends TodoTask>(
  tasks: T[],
  planned: Map<string, TodoEntry>,
  categories: TodoCategory[],
  filter: string | null = null,
): TodoGroups<T> {
  const shown = tasks.filter((t) => !filter || t.category_id === filter);
  const fresh = shown.filter((t) => t.status === "inbox" && t.ai_state !== "review" && !planned.has(t.id)).sort(newestFirst);

  const byDate = new Map<string, T[]>();
  for (const t of shown) {
    const entry = planned.get(t.id);
    if (!entry || (t.status !== "open" && t.status !== "inbox")) continue;
    byDate.set(entry.plan_date, [...(byDate.get(entry.plan_date) ?? []), t]);
  }
  const plannedGroups = [...byDate].sort(([a], [b]) => (a < b ? -1 : 1)).map(([date, list]) => ({ date, tasks: list.sort(oldestFirst) }));

  const open = shown.filter((t) => t.status === "open" && !planned.has(t.id));
  const known = new Set(categories.map((c) => c.id));
  const undated = [...categories]
    .sort((a, b) => a.position - b.position)
    .map((category) => ({
      category: category as TodoCategory | null,
      tasks: open.filter((t) => t.category_id === category.id).sort(oldestFirst),
    }));
  // Overig: no kind, or one that was removed.
  undated.push({ category: null, tasks: open.filter((t) => !t.category_id || !known.has(t.category_id)).sort(oldestFirst) });

  return { fresh, planned: plannedGroups, undated: undated.filter((g) => g.tasks.length) };
}
